import React from "react";

import type { MeetingPlatform } from "@app/common/types";

import LogomarkWithGradient from "@rui/LogomarkWithGradient";
import { Img } from "@rui/styles";

import { Wrapper, ImageContainer, ThumbnailIcon } from "./styles";

export interface ThumbnailProps {
  src?: string | null;
  platform?: MeetingPlatform | "upload";
}

const LOGOMARK_SX = {
  height: "20px",
  width: "20px",
  padding: "2.5px",
  borderRadius: "6px",
};

const Thumbnail = ({ src, platform = "unknown" }: ThumbnailProps) => {
  return (
    <Wrapper variant="center">
      <ImageContainer
        sx={{ border: src ? "none" : undefined }}
        variant="center"
      >
        {src ? (
          <Img
            src={src}
            sx={{ width: "100%", objectFit: "cover", height: "100%" }}
          />
        ) : (
          <LogomarkWithGradient sx={LOGOMARK_SX} />
        )}
        {platform !== "unknown" && (
          <ThumbnailIcon size="sm" source={platform} />
        )}
      </ImageContainer>
    </Wrapper>
  );
};

export default Thumbnail;
